import React from 'react';

export default function Intro({ children, className, to }) {
  return (
		<iframe id="intro" src="https://www.tjjjia.work/ccd/coin-fx.html"></iframe>
  );
}



// WEBPACK FOOTER //
// ./src/components/intro.js